import React from "react";
import { useTranslation } from "react-i18next";
export default function RestartOfflineScan(props) {
  const { t } = useTranslation();
  return (
    <>
      <div className="error-popup open">
        <div className="error-info">
          <div className="content">
            <p className="content-title">
              <b>Important Notice</b>
            </p>
            <p>
              Initiating the offline inspection restart will result in the
              deletion of all prior video recordings and captured photos
            </p>
          </div>
          <div className="bottom-btn">
            <button className="gray-btn" onClick={() => props.Cancel()}>
              {t("BUTTONS.Cancel")}
            </button>
            <button className="blue-btn" onClick={() => props.Continue()}>
              Continue
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
